module.exports = __webpack_public_path__ + "img/czleader4.bcf08dff.png";